var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModelsActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "models-active") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.93933578,12.7777778 C4.54765779,16.4037448 7.70117141,19.1666667 11.5,19.1666667 C15.2988286,19.1666667 18.4523422,16.4037448 19.0606642,12.7777778 L15.3333333,12.7777778 C15.3333333,14.8948693 13.6170915,16.6111111 11.5,16.6111111 C9.38290846,16.6111111 7.66666667,14.8948693 7.66666667,12.7777778 L3.93933578,12.7777778 Z M4.26958125,8.94444444 L18.7304187,8.94444444 C17.6779479,5.9667306 14.8381148,3.83333333 11.5,3.83333333 C8.16188522,3.83333333 5.32205207,5.9667306 4.26958125,8.94444444 Z M11.5,23 C5.14872538,23 0,17.8512746 0,11.5 C0,5.14872538 5.14872538,0 11.5,0 C17.8512746,0 23,5.14872538 23,11.5 C23,17.8512746 17.8512746,23 11.5,23 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "models-active",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 11.5,
    cy: 11.5,
    r: 11.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("path", {
    strokeOpacity: 0.5,
    stroke: "#FFFFFF",
    d: "M3.44622719,12.8605057 L3.34846396,12.2777778 L3.93933578,12.2777778 L8.16666667,12.2777778 L8.16666667,12.7777778 C8.16666667,14.6187269 9.65905083,16.1111111 11.5,16.1111111 C13.3409492,16.1111111 14.8333333,14.6187269 14.8333333,12.7777778 L14.8333333,12.2777778 L19.651536,12.2777778 L19.5537728,12.8605057 C18.8984228,16.7667883 15.5034867,19.6666667 11.5,19.6666667 C7.49651333,19.6666667 4.10157723,16.7667883 3.44622719,12.8605057 Z M19.4374561,9.44444444 L3.56254388,9.44444444 L3.79816131,8.7778214 C4.94214581,5.54119154 8.01118613,3.33333333 11.5,3.33333333 C14.9888139,3.33333333 18.0578542,5.54119154 19.2018387,8.7778214 L19.4374561,9.44444444 Z M11.5,22.5 C17.5751322,22.5 22.5,17.5751322 22.5,11.5 C22.5,5.42486775 17.5751322,0.5 11.5,0.5 C5.42486775,0.5 0.5,5.42486775 0.5,11.5 C0.5,17.5751322 5.42486775,22.5 11.5,22.5 Z",
    strokeLinejoin: "square",
    fill: "#FE5620",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#2E2B2B",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelsActive);
export default __webpack_public_path__ + "static/media/models-active.c0d422acdc1287b71b32671f1d457b59.svg";
export { ForwardRef as ReactComponent };